export const defaultLocale = "uz" as const

export enum ELang {
  RU = "ru",
  UZ = "uz",
  UZ_CR = "uzKr"
}

export type ILangKey = "uz" | "ru" | "uzKr"

export type ILang = {
  ru: string
  uz: string
  uzKr: string
}
export type ILangLabel = "РУ" | "O‘Z" | "ЎЗ"

export type ILangOption = { value: keyof ILang; label: ILangLabel }

export const LANG_OPTIONS: ILangOption[] = [
  { value: "ru", label: "РУ" },
  { value: "uz", label: "O‘Z" }
  // { value: "uzKr", label: "ЎЗ" }
] as const

export const SHORT_LANG: Record<keyof ILang, ILangLabel> = { ru: "РУ", uz: "O‘Z", uzKr: "ЎЗ" }

export const LANG_I18KEYS: Record<keyof ILang, ILangKey> = {
  ru: "ru",
  uz: "uz",
  uzKr: "uzKr"
}

interface IOptionMultiLang<T> {
  value: T
  labels: ILang
  meta?: { init: ILang }
}

export const Months: IOptionMultiLang<number>[] = [
  { value: 1, labels: { ru: "Январь", uzKr: "Январь", uz: "Yanvar" } },
  { value: 2, labels: { ru: "Февраль", uzKr: "Февраль", uz: "Fevral" } },
  { value: 3, labels: { ru: "Март", uzKr: "Март", uz: "Mart" } },
  { value: 4, labels: { ru: "Апрель", uzKr: "Апрель", uz: "Aprel" } },
  { value: 5, labels: { ru: "Май", uzKr: "Май", uz: "May" } },
  { value: 6, labels: { ru: "Июнь", uzKr: "Июнь", uz: "Iyun" } },
  { value: 7, labels: { ru: "Июль", uzKr: "Июль", uz: "Iyul" } },
  { value: 8, labels: { ru: "Август", uzKr: "Август", uz: "Avgust" } },
  { value: 9, labels: { ru: "Сентябрь", uzKr: "Сентябрь", uz: "Sentabr" } },
  { value: 10, labels: { ru: "Октябрь", uzKr: "Октябрь", uz: "Oktabr" } },
  { value: 11, labels: { ru: "Ноябрь", uzKr: "Ноябрь", uz: "Noyabr" } },
  { value: 12, labels: { ru: "Декабрь", uzKr: "Декабрь", uz: "Dekabr" } }
]

export const daysOfWeek: IOptionMultiLang<number>[] = [
  {
    value: 1,
    labels: { ru: "Понедельник", uzKr: "Душанба", uz: "Dushanba" },
    meta: { init: { ru: "Пн", uzKr: "Ду", uz: "Du" } }
  },
  {
    value: 2,
    labels: { ru: "Вторник", uzKr: "Сешанба", uz: "Seshanba" },
    meta: { init: { ru: "Вт", uzKr: "Сe", uz: "Se" } }
  },
  {
    value: 3,
    labels: { ru: "Среда", uzKr: "Чоршанба", uz: "Chorshanba" },
    meta: { init: { ru: "Ср", uzKr: "Чо", uz: "Cho" } }
  },
  {
    value: 4,
    labels: { ru: "Четверг", uzKr: "Пайшанба", uz: "Payshanba" },
    meta: { init: { ru: "Чт", uzKr: "Пa", uz: "Pa" } }
  },
  {
    value: 5,
    labels: { ru: "Пятница", uzKr: "Жума", uz: "Juma" },
    meta: { init: { ru: "Пт", uzKr: "Ж", uz: "Ju" } }
  },
  {
    value: 6,
    labels: { ru: "Суббота", uzKr: "Шанба", uz: "Shanba" },
    meta: { init: { ru: "Сб", uzKr: "Ш", uz: "Sha" } }
  },
  {
    value: 7,
    labels: { ru: "Воскресенье", uzKr: "Якшанба", uz: "Yakshanba" },
    meta: { init: { ru: "Вс", uzKr: "Як", uz: "Yak" } }
  }
]

const validLangs: ILangKey[] = ["uz", "ru", "uzKr"]
export const currLang: ILangKey = validLangs.includes(localStorage.getItem("i18nextLng") as ILangKey)
  ? (localStorage.getItem("i18nextLng") as ILangKey)
  : defaultLocale

export const daysOfWeekOptions = daysOfWeek.map(day => ({
  label: day.labels[currLang],
  value: day.value,
  meta: { init: day.meta?.init[currLang] }
}))
